import { Outlet } from 'react-router-dom';
import { WebsiteNavbar } from './WebsiteNavbar';
import { WebsiteFooter } from './WebsiteFooter';

export function WebsiteLayout() {
  return (
    <div className="min-h-screen bg-white">
      <WebsiteNavbar />
      <Outlet />
      <WebsiteFooter />
    </div>
  );
}
